import { agent as baseAgent, compareVersion, checkAgent } from './base'
import miniapp from './mp-agent'
import { APP_NAME, I_AGENT, I_APP_AGENT, I_MP_AGENT, I_UA_INFO } from './typing'

// -1 a < b
// 0 a = b
// 1 a > b
export { compareVersion, checkAgent }

function getNativeVersion(uaInfo: I_UA_INFO) {
  let version: string | undefined
  if (uaInfo.meituangroup) {
    version = uaInfo.meituangroup
  } else if (uaInfo.dp) {
    version = uaInfo.dp
  } else if (uaInfo.phoenix) {
    version = uaInfo.phoenix
  }
  return version || uaInfo.version
}

function native(ua: string, uaInfo: I_UA_INFO): I_APP_AGENT {
  const agent: I_APP_AGENT = {
    version: getNativeVersion(uaInfo),
    dianping: false,
    meituan: false,
    phx: false,
    appnm: APP_NAME.phoenix_i,
  }
  if (ua.indexOf('com.dianping') !== -1) {
    agent.dianping = true
    agent.appnm = APP_NAME.dianping_nova
  } else if (ua.indexOf('meituangroup') !== -1) {
    agent.meituan = true
    agent.appnm = APP_NAME.group
  } else if (/phoenix\/com\.meituan\.phoenix/.test(ua)) {
    agent.phx = true
    agent.appnm = APP_NAME.phoenix
  } else if (ua.indexOf('openharmony') !== -1 && ua.indexOf('phoenix/') !== -1) {
    // 鸿蒙系统且包含phoenix/的美团APP
    agent.phx = true
    agent.appnm = APP_NAME.phoenix
  }
  return agent
}

export function agent(_ua = ''): I_AGENT {
  const ua = _ua.toLowerCase()
  const Agent = baseAgent(ua)
  let miniprogram = Agent.miniprogram
  let anyminiprogram = Agent.anyminiprogram
  const NatvieAgent = Agent.android_Ios_HarmonyNative ? native(ua, Agent.uaInfo) : {}
  const MiniAppAgent: I_MP_AGENT = Agent.weixin || Agent.swan ? miniapp(ua) : undefined
  if (Agent.weixin && MiniAppAgent) {
    // 从微信7.0.0开始，可以通过判断userAgent中包含miniProgram字样来判断小程序webview环境，ios低版本仍依赖appnm
    miniprogram = !!(Agent.miniprogram || (Agent.weixin && MiniAppAgent.appnm))
  }
  if (miniprogram || Agent.swan) {
    // 任意小程序
    anyminiprogram = true
  }
  const FAgent: I_AGENT = {
    appnm: APP_NAME.phoenix_i,
    version: '1',
    ...Agent,
    ...NatvieAgent,
    ...MiniAppAgent,
    miniprogram,
    anyminiprogram,
  }
  return FAgent
}

export default agent(navigator.userAgent)
// export default agent(
//   'Mozilla/5.0 (iPhone; CPU iPhone OS 13_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 TitansX/11.30.11 KNB/1.0 iOS/13.5.1 meituangroup/com.meituan.imeituan/11.0.201 meituangroup/11.0.201 App/10110/11.0.201 iPhone/iPhone11ProMax WKWebView',
// )
// export default agent(
//   '"Mozilla/5.0 (iPhone; CPU iPhone OS 16_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 TitansX/20.0.1.old KNB/1.0 iOS/16.1 phoenix/com.meituan.phoenix.pro/7.7.0 phoenix/7.7.0 App/10d11/7.7.0 iPhone/iPhone14ProMax WKWebView"',
// )
